import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import { AppLayout } from "@/components/AppLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LoginPage } from "@/pages/LoginPage";
import { ProductListPage } from "@/pages/ProductListPage";
import { ReportPage } from "@/pages/ReportPage";
import { StatsPage } from "@/pages/StatsPage";
import { UsersPage } from "@/pages/UsersPage";
import { BannerPage } from "@/pages/BannerPage";

// ProductDetailPage pulls in recharts (~400kB) — lazy-load it so the
// initial bundle stays small. Other pages are kept eager since they're
// part of the post-login landing experience.
const ProductDetailPage = lazy(() =>
  import("@/pages/ProductDetailPage").then((m) => ({ default: m.ProductDetailPage })),
);

const PageFallback = () => (
  <div className="text-slate-500 text-sm">Loading…</div>
);

// Mirrors mutalisk's screen layout (banner / login / product-list / product-detail
// / user / role) but compressed: role-management UI is folded into UsersPage.
export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <ProtectedRoute><AppLayout /></ProtectedRoute>,
    children: [
      { index: true, element: <Navigate to="/products" replace /> },
      { path: "products",        element: <ProductListPage /> },
      { path: "products/:mp",    element: <Suspense fallback={<PageFallback />}><ProductDetailPage /></Suspense> },
      { path: "stats",           element: <StatsPage /> },
      { path: "report",          element: <ReportPage /> },
      { path: "users",           element: <UsersPage /> },
      { path: "banner",          element: <BannerPage /> },
    ],
  },
  { path: "*", element: <Navigate to="/products" replace /> },
]);
